export function formatAmountDisplay(value: string): string {
    if (!value) return '';
    const [intPart, ...decParts] = value.split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decParts.length > 0
        ? `${formattedInt}.${decParts.join('.')}`
        : formattedInt;
}
